import React from 'react';
import { DateMultiPickerCompat as DateMultiPickerCompatNew } from './DateMultiPickerCompat';
import { convertOldDateMultiPickerProps, OldDateMultiPickerProps } from './converter.old';

export type DateMultiPickerProps = OldDateMultiPickerProps;
export type DateMultiPickerCompatProps = DateMultiPickerProps;
export const DateMultiPickerCompat: React.FC<DateMultiPickerProps> = (props) => (
  <DateMultiPickerCompatNew {...convertOldDateMultiPickerProps(props)} />
);
